import { formatInTimeZone } from 'date-fns-tz';

export function formatDate(date: string | Date, timezone: string) {
  if (!date) return '';
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date value:', date);
      return '';
    }
    return formatInTimeZone(
      dateObj,
      timezone || 'UTC',
      "PPP 'at' p"
    );
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

export function convertToUserTimezone(date: string | Date, timezone: string) {
  if (!date) return null;
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) {
      console.error('Invalid date value:', date);
      return null;
    }
    return formatInTimeZone(dateObj, timezone || 'UTC', "yyyy-MM-dd'T'HH:mm:ssXXX");
  } catch (error) {
    console.error('Error converting date to user timezone:', error);
    return null;
  }
}